<template>
  <el-dialog append-to-body :title="title" :visible.sync="dialogFormVisible" style="width:1200px;margin:auto;" @close="close" :close-on-click-modal="false">     
      <div class="veteranDetail" v-loading="loading" :element-loading-text="elementLoadingText">
        <div class="veteranBaseInfo">
          <div class="veteranPhoto" v-if="form.id>0">
              <img class="photo" :src="form.photo" />
              <img v-if="form.sex==0||form.sex==false" class="sex" src="https://file-sz.fjjykj.com.cn/Supply/s6e13598728334b924712b04a842b4eef.png" />
              <img v-else class="sex" src="https://file-sz.fjjykj.com.cn/Supply/sd2ffec0974c7f31c402e31a89c6e4d8b.png" />
          </div>
          <div v-if="form.id>0" class="veteranName">{{form.name}}<span>{{form.age}}岁</span></div>        
        </div>
        <div class="veteranHardInfo">困难说明</div>
        <div class="veteranHardInfoContent" v-html="form.hardInfo"></div>
        <div class="veteranFile">
          <img v-for="(item,index) in form.files" :key="index" :src="item"/>
        </div>
      </div>  
  </el-dialog>
</template>
<style>
@import '../../../styles/selectVeteran.css';
</style>
<script>
import { getVeteran} from '@/api/order'
export default {
  name: 'veteranDetail',
  components: {  },
  data() {
    return {
      title:'',  
      elementLoadingText: '数据加载中，请稍后...',     
      loading:false,
      dialogFormVisible: false,
      form:{
        id:0,
      },
    }
  },
  created() {   
  },
  methods: {
    async show(row) {
      this.form= {
        id:0,
      };
      this.title = '帮扶人员（'+row.name+'）详情'       
      this._getAllVeteran(row.id);
      this.dialogFormVisible = true
    },       
    close() {
      this.dialogFormVisible = false
    }, 
    async _getAllVeteran(tempId)
    {
     // this.loading=true;    
      getVeteran({id:tempId}).then(res=>{
        debugger;
        if(res.data&&res.data.result)
        {
          this.form = res.data.result;       
        }
        //this.loading=false;
       })    
      
    }   
  },
}
</script>
<style>
.v-modal
{
  z-index: 200 !important;
}
</style>



// WEBPACK FOOTER //
// VeteranDetail.vue?8107822e